import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { CreatePasswordFormComponent } from '../../../../components/forms/dynamic-forms/create-password-form/create-password-form.component';
import { CreateNewPasswordSvgComponent } from '../../../../modules/mapfre-design-library/src/lib/svg/create-new-password-svg/create-new-password-svg.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

import { CreateNewPasswordFormService } from '@services/forms/forgot-password/create-new-password-form/create-new-password-form.service';
import { Location } from '@angular/common';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, CreateNewPasswordSvgComponent, CreatePasswordFormComponent, MapfreButtonComponent],
  selector: 'app-signup-create-password',
  templateUrl: './signup-create-password.component.html',
})
export class SignupCreatePasswordComponent implements OnInit {
  createNewPassword: any[];
  isAcmic: boolean;

  constructor(
    private passwordService: CreateNewPasswordFormService,
    private location: Location,
    private acmicService: AcmicService,
  ) {
    this.isAcmic = this.acmicService.isACMIC();
  }

  ngOnInit() {
    this.createNewPassword = this.passwordService.getInputs();
  }

  goBackAPage() {
    this.location.back();
  }

}
